import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { Result } from "../models/common/resultResponse";
import { IDamageSubCategoryApi } from "./base/damageSubCategoryApi";
import { DamageSubCategoryRequest, DeleteDamageSubCategoryRequest } from "../models/request/damageSubCategoryRequest";
import { DamageCategoryResponse } from "@/main/models/response/damageCategoryResponse";

const baseRoute: string = "DamageSubCategory";

export class DamageSubCategoryApi extends IDamageSubCategoryApi {
	getDamageCategoriesSubCategories(guidInsurer: string): Promise<AxiosResponse<Result<DamageCategoryResponse[]>>> {
		return api.get(`${baseRoute}/getalldamagecategoryandsubcategory`, {
			params: { guidInsurer },
		});
	}

	saveDamageSubCategory(request: DamageSubCategoryRequest): Promise<AxiosResponse<Result<any>, any>> {
		return api.post(`${baseRoute}/savedamagesubcategory`, request);
	}

	inactiveDamageSubCategory(request: DeleteDamageSubCategoryRequest): Promise<AxiosResponse<Result<any>>> {
		return api.post(`${baseRoute}/inactivedamagesubcategory`, request);
	}
}
